import React from 'react';
import Chip from '@material-ui/core/Chip';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  stack: {
    display: 'flex',
    justifyContent: 'start',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.2),
    },
  },
  icon: {
    width: '18px !important',
    height: '18px !important',
  },
}));

function Tags({ allTags = [], tags = [], type }) {
  const classes = useStyles();

  return (
    <Box className={classes.stack} pb={type === 'single' ? 2 : undefined}>
      {Array.isArray(tags) &&
        tags?.map((item) => {
          if (!item) return null;

          let tag;
          if (typeof item === 'number') {
            tag = allTags.find((tag) => tag.tag_id === item);
          } else {
            tag = item;
          }

          if (!tag) return null;

          const { detail = {} } = tag;
          let iconElement = null;
          if (detail?.icon) {
            iconElement =
              typeof detail.icon === 'string' ? (
                <Avatar
                  className={classes.icon}
                  src={detail.icon}
                  alt={tag.name || 'tag-icon'}
                  style={{
                    backgroundColor: 'transparent',
                    color: 'transparent',
                    borderRadius: 4,
                  }}
                />
              ) : (
                detail.icon
              );
          }

          return (
            <Chip
              key={tag.tag_id || tag.name}
              label={tag.value}
              avatar={iconElement}
              style={{
                backgroundColor: detail?.background_color
                  ? `#${detail.background_color}`
                  : 'default',
                color: detail?.foreground_color
                  ? `#${detail.foreground_color}`
                  : 'inherit',
              }}
              size='small'
            />
          );
        })}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  allTags: state?.menuReducer?.tags ?? [],
});

export default connect(mapStateToProps)(Tags);
